(function() {
  'use strict';
  if (window.__gmCartBadge) return;

  function cartRoot() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  }

  function badgeEls() {
    return {
      btn: document.querySelector('[data-gm-cart-btn]'),
      badge: document.querySelector('[data-gm-cart-badge]')
    };
  }

  function setCount(count, animate) {
    var els = badgeEls();
    if (!els.badge) return;
    var n = Math.max(0, Number(count) || 0);
    els.badge.textContent = n > 99 ? '99+' : String(n);
    if (n <= 0) {
      els.badge.hidden = true;
      els.badge.setAttribute('aria-hidden', 'true');
    } else {
      els.badge.hidden = false;
      els.badge.removeAttribute('aria-hidden');
    }
    if (els.btn) {
      els.btn.setAttribute('aria-label', n === 1 ? 'cart, 1 item' : 'cart, ' + n + ' items');
    }
    if (animate && n > 0) {
      if (els.btn) {
        els.btn.classList.remove('is-cart-bump');
        void els.btn.offsetWidth;
        els.btn.classList.add('is-cart-bump');
      }
      els.badge.classList.remove('is-bump');
      void els.badge.offsetWidth;
      els.badge.classList.add('is-bump');
    }
  }

  function refresh(animate) {
    return fetch(cartRoot() + 'cart.js', { credentials: 'same-origin' })
      .then(function(res) {
        if (!res.ok) throw new Error('cart fetch failed');
        return res.json();
      })
      .then(function(cart) {
        setCount(cart && cart.item_count, animate !== false);
        return cart;
      })
      .catch(function() {
        return null;
      });
  }

  window.__gmCartBadge = {
    setCount: setCount,
    refresh: refresh,
    bump: function() { return refresh(true); }
  };
})();
